import { createModule } from '../createModule';

export const contractor = createModule('contractor');